import styled, { css } from "styled-components";
import { color, onHover, units, variant } from "@m/alchemy-theme";
import { AppMenuButtonIconWrapper, AppMenuButtonNakedButton } from "../app-menu-button/AppMenuButton.styled";
import { ButtonGroup } from "../../button-group/ButtonGroup.styled";
import { SplitButtonContents } from "../../split-button/SplitButton.styled";
import { navHeight } from "../navHeight";
export const AppBar = styled.section `
  padding: 0 ${units(2)};
  width: 100%;
  color: ${color("typeHeader")};
  overflow: hidden;

  ${({ backgroundImage }) => backgroundImage &&
    css `
      background-image: url(${backgroundImage});
      background-size: cover;
      background-position: right center;
      background-repeat: no-repeat;
    `};

  ${({ bottomBorderColor }) => bottomBorderColor &&
    css `
      border-bottom: 1px solid ${bottomBorderColor};
    `};

  ${variant("colorScheme", {
    alchemyLight: css `
      background-color: ${color("container")};

      ${onHover(css `
          ${AppMenuButtonIconWrapper} {
            background-color: rgba(44, 53, 72, 0.1);

            svg {
              color: ${color("typeHeader")};
              opacity: 1;
            }
          }
        `, { includeActive: true, selector: `${AppMenuButtonNakedButton}` })}
    `,
    alchemyDark: css `
      background-color: ${color("fill")};

      ${onHover(css `
          ${AppMenuButtonIconWrapper} {
            background-color: rgba(255, 255, 255, 0.2);

            svg {
              color: ${color("typeHeader")};
              opacity: 1;
            }
          }
        `, { includeActive: true, selector: `${AppMenuButtonNakedButton}` })}
    `,
    alchemyBrand: css `
      background-color: ${color("container")};
    `,
    alchemyPanel: ``
})};

  ${({ priority, backgroundColor }) => priority === "secondary" &&
    !backgroundColor &&
    css `
      background-color: ${color("brandPrimary", { lighten: 0.035 })};
    `};

  ${({ backgroundColor }) => backgroundColor &&
    css `
      background-color: ${backgroundColor};
    `};

  ${ButtonGroup} {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    button:not(:last-child) {
      margin-right: ${units(0.75)};
    }

    //Special handling for the two buttons in SplitButton DES-2976
    ${SplitButtonContents} button:first-child {
      margin-right: 1px;
    }
  }
`;
export const AppBarContent = styled.div `
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  width: 100%;
  margin: auto;
  max-width: ${({ priority }) => (priority === "adminPrimary" || priority === "adminSecondary" ? "100%" : "1600px")};

  ${({ priority }) => priority &&
    css `
      ${navHeight({ priority })};
    `};
`;
